import assest from '@/json/assest'
import { Box, Breadcrumbs, Container, styled, Typography } from '@mui/material'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const HeaderInner = styled(Box)`
    .headerInnerWrapper{
        border-top: 1px solid #EEEEEE;
        border-bottom: 1px solid #EEEEEE;
        padding: 26px 0;
        margin-top: 143px;
        @media (max-width: 899px) {
            margin-top: 123px;
        }
        @media (max-width: 599px) {
            margin-top: 90px;
            padding: 10px 0;
        }
        .headerInner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            h1{
                font-weight: 500;
                font-size: 35px;
                line-height: 2;
                color: #1E294C;
                font-family: 'Roboto', sans-serif;
                @media (max-width: 599px) {
                    font-size: 25px;
                }

                span {
                    color: #73C2FB;
                }
            }
            .MuiBreadcrumbs-root{
                ol{
                    li{
                        display: flex;
                        align-items: center;
                        a{
                            font-weight: 400;
                            font-size: 18px;
                            line-height: 1.4;
                            color: #65676A;
                            font-family: 'Ubuntu', sans-serif;
                            display: flex;
                            align-items: center;
                            &:hover{
                                color:#73C2FB;
                            }
                            img{
                                margin-right: 7px;
                            }
                        }
                        p{
                            font-weight: 400;
                            font-size: 18px;
                            line-height: 1.4;
                            color: #73C2FB;
                            font-family: 'Ubuntu', sans-serif;
                            font-family: 'Ubuntu',sans-serif;
                            display: flex;
                            span{
                                margin: 0 20px;
                                display: inline-block;
                                img{
                                    width: 100%;
                                    height: auto;
                                }
                            }
                        }
                        &.MuiBreadcrumbs-separator{
                            text-indent: -10000px;
                            display: none;
                        }
                    }
                }
            }
        }
    }
`

interface headerProps {
    name: any;
    pageName: string;
}

const CommonHeaderInner = ({ name, pageName }: headerProps) => {
    return (
        <HeaderInner>
            <Box className="headerInnerWrapper">
                <Container fixed>
                    <Box className='headerInner'>
                        <h1>{name}</h1>

                        <Breadcrumbs aria-label="breadcrumb">
                            <Link href="/">
                                <Image src={assest.homeIcon} width={16} height={20} alt="img" /> Home
                            </Link>
                            <Typography><span><Image src={assest.arrowGray} width={3} height={6} alt="img" /></span> {pageName}</Typography>
                        </Breadcrumbs>
                    </Box>
                </Container>
            </Box>
        </HeaderInner>
    )
}

export default CommonHeaderInner